import { createAction } from '../util/index.js';


export const clearArchive= createAction('CLEAR_ARCHIVE', requestObject => requestObject)
